
import { JsonObject, JsonProperty } from 'json2typescript';
import { ClaimType } from './claimType';


@JsonObject('Claim')
export class Claim {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('claim_type', ClaimType, true)
    claimType: ClaimType = null;

    @JsonProperty('currency', String, true)
    currency = null;

    @JsonProperty('amount', Number, true)
    amount = null;

    // write data
    @JsonProperty('claim_type_id', Number, true)
    claimTypeId: number = undefined;

    @JsonProperty('case_id', Number, true)
    case_id: number = undefined;

    get claimTypeStr() {
        return this.claimType?.typeStr;
    }

    get amountCurrency() {
        return `${this.amount} ${this.currency}`;
    }
}